"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line2 = exports.Line1 = exports.PinterestButton = exports.HeartButton = exports.ImageWrapper = exports.Wrapp = exports.Item = exports.Grid = exports.ContainerStyled = exports.StyledBox = exports.Preview = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _styled = require("../../styled");

var _carousel = require("../carousel/carousel.styled");

var _helpers = require("../../helpers");

var _const = require("../../const");

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  margin-bottom: 5px;\n  text-transform: capitalize;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  ", ";\n  margin-bottom: 5px;\n  min-height: 16px;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  left: 20px;\n\n  &:hover {\n    color: ", " !important;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  right: 20px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: absolute;\n  top: 14px;\n\n  svg,\n  svg * {\n    fill: currentColor;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  padding-bottom: ", "%;\n  position: relative;\n\n  img {\n    height: 100%;\n    left: 0;\n    object-fit: cover;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        max-width: ", "px;\n\n        .slick-control {\n          display: block;\n        }\n      }\n\n      ", " {\n        max-width: ", "px;\n      }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        max-width: 100%;\n        width: 100%;\n\n        .slick-slider {\n          padding: 0;\n          margin: 0;\n\n          .slick-track {\n            margin-left: ", "px;\n          }\n\n          .slick-list {\n            padding: 0 14px;\n          }\n        }\n\n        .slick-control {\n          display: none;\n        }\n      }\n      ", " {\n        .slick-slider {\n          .slick-track {\n            margin-left: 10px;\n          }\n        }\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  padding-top: 48px;\n  position: relative;\n  max-width: ", ";\n\n  .slick-control {\n    ", "\n    &:first-child {\n      left: -30px;\n      ", " {\n        left: -20px;\n      }\n    }\n    &:last-child {\n      right: -30px;\n      ", " {\n        right: -20px;\n      }\n    }\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n            width: 100%;\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            padding: 0 10px;\n            width: ", "px;\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  cursor: pointer;\n  display: inline-block;\n  max-width: ", ";\n  padding: ", "px;\n  position: relative;\n  width: 100%;\n\n  ", " {\n    max-width: ", ";\n    width: ", ";\n  }\n\n  ", " {\n    max-width: ", ";\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  left: -15px;\n  position: relative;\n  width: calc(100% + 30px);\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        padding: 0;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n\n  ", " {\n    top: ", ";\n    transform: translateY(-100%);\n  }\n\n  ", " {\n    padding: 0 24px;\n    max-width: 100%;\n\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 0;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      padding: 30px 0;\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n\n  &:before {\n    height: ", "px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: -1;\n  }\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  display: flex;\n  font-size: 16px;\n  font-weight: bold;\n  height: 100%;\n  left: 0;\n  letter-spacing: 0.25em;\n  position: absolute;\n  top: 0;\n  justify-content: center;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var offset = 30;
var Preview = (0, _uiKit.styled)("div")(_templateObject(), _uiKit.Colors.white, _uiKit.Colors.gray400);
exports.Preview = Preview;
var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject2(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
}, function (_ref2) {
  var $decorHeight = _ref2.theme.$decorHeight;
  return $decorHeight || 0;
}, function (_ref3) {
  var removeTopPadding = _ref3.removeTopPadding,
      removeBottomPadding = _ref3.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject3(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
});
exports.StyledBox = StyledBox;
var ContainerStyled = (0, _uiKit.styled)(_uiKit.Container)(_templateObject4(), _carousel.Arrow, function (_ref4) {
  var $imageHeight = _ref4.theme.$imageHeight;
  return $imageHeight ? "".concat($imageHeight * 0.5, "px") : '50%';
}, _uiKit.GridBreakpointsMediaDown.lg, function (_ref5) {
  var $mobileLayout = _ref5.theme.$mobileLayout;
  return $mobileLayout === _const.MobileLayouts.SCROLL && (0, _uiKit.css)(_templateObject5());
});
exports.ContainerStyled = ContainerStyled;
var Grid = (0, _uiKit.styled)("div")(_templateObject6(), _uiKit.GridBreakpointsMediaDown.lg);
exports.Grid = Grid;
var Item = (0, _uiKit.styled)("a")(_templateObject7(), function (_ref6) {
  var _ref6$theme = _ref6.theme,
      $itemsWidth = _ref6$theme.$itemsWidth,
      $isLayoutFullWidth = _ref6$theme.$isLayoutFullWidth;
  return $itemsWidth.xl === 0 || $isLayoutFullWidth ? 'none' : "".concat($itemsWidth.xl + 100 + offset, "px");
}, function (_ref7) {
  var _ref7$theme = _ref7.theme,
      $isLayoutFullWidth = _ref7$theme.$isLayoutFullWidth,
      $mobileLayout = _ref7$theme.$mobileLayout;
  return $isLayoutFullWidth && $mobileLayout === _const.MobileLayouts.SCROLL ? "0 15" : "0 10";
}, _uiKit.GridBreakpointsMediaDown.lg, function (_ref8) {
  var _ref8$theme = _ref8.theme,
      $itemsWidth = _ref8$theme.$itemsWidth,
      $isLayoutFullWidth = _ref8$theme.$isLayoutFullWidth;
  return $isLayoutFullWidth ? 'none' : "".concat($itemsWidth.lg + offset, "px");
}, function (_ref9) {
  var _ref9$theme = _ref9.theme,
      $mobileLayout = _ref9$theme.$mobileLayout,
      $itemsWidth = _ref9$theme.$itemsWidth;
  return $mobileLayout === _const.MobileLayouts.SCROLL ? "".concat($itemsWidth.lg + offset, "px") : '100%';
}, _uiKit.GridBreakpointsMediaDown.md, function (_ref10) {
  var _ref10$theme = _ref10.theme,
      $itemsWidth = _ref10$theme.$itemsWidth,
      $isLayoutFullWidth = _ref10$theme.$isLayoutFullWidth;
  return $isLayoutFullWidth ? 'none' : "".concat($itemsWidth.md + offset, "px");
}, function (_ref11) {
  var _ref11$theme = _ref11.theme,
      $mobileLayout = _ref11$theme.$mobileLayout,
      $itemsWidth = _ref11$theme.$itemsWidth;
  return $mobileLayout === _const.MobileLayouts.SCROLL ? (0, _uiKit.css)(_templateObject8(), $itemsWidth.lg + offset) : (0, _uiKit.css)(_templateObject9());
});
exports.Item = Item;
var Wrapp = (0, _uiKit.styled)("div")(_templateObject10(), function (_ref12) {
  var _ref12$theme = _ref12.theme,
      $isLayoutFullWidth = _ref12$theme.$isLayoutFullWidth,
      $itemsWidth = _ref12$theme.$itemsWidth,
      $itemsPerRow = _ref12$theme.$itemsPerRow;
  return !$isLayoutFullWidth ? "".concat(($itemsWidth.xl + offset) * $itemsPerRow.xl + 100 + offset, "px") : 'none !important';
}, _carousel.CarouselDefaultArrowStyles, _uiKit.GridBreakpointsMediaDown.lg, _uiKit.GridBreakpointsMediaDown.lg, function (_ref13) {
  var _ref13$theme = _ref13.theme,
      $mobileLayout = _ref13$theme.$mobileLayout,
      $isLayoutFullWidth = _ref13$theme.$isLayoutFullWidth;
  return $mobileLayout === _const.MobileLayouts.SCROLL && (0, _uiKit.css)(_templateObject11(), _uiKit.GridBreakpointsMediaDown.lg, $isLayoutFullWidth ? 15 : 10, _uiKit.GridBreakpointsMediaDown.md);
}, function (_ref14) {
  var _ref14$theme = _ref14.theme,
      $mobileLayout = _ref14$theme.$mobileLayout,
      $itemsPerRow = _ref14$theme.$itemsPerRow,
      $itemsWidth = _ref14$theme.$itemsWidth;
  return $mobileLayout === _const.MobileLayouts.CAROUSEL && (0, _uiKit.css)(_templateObject12(), _uiKit.GridBreakpointsMediaDown.lg, ($itemsWidth.lg + offset) * $itemsPerRow.lg - offset + 100, _uiKit.GridBreakpointsMediaDown.md, $itemsWidth.md + offset + 100);
});
exports.Wrapp = Wrapp;
var ImageWrapper = (0, _uiKit.styled)("div")(_templateObject13(), 100 / 2 * 3);
exports.ImageWrapper = ImageWrapper;
var StyledButton = (0, _uiKit.styled)(_uiKit.Button)(_templateObject14(), _uiKit.Colors.white);
var HeartButton = (0, _uiKit.styled)(StyledButton)(_templateObject15(), function (_ref15) {
  var isFav = _ref15.isFav;
  return isFav && (0, _uiKit.css)(_templateObject16(), _uiKit.Colors.primary);
});
exports.HeartButton = HeartButton;
var PinterestButton = (0, _uiKit.styled)(StyledButton)(_templateObject17(), _uiKit.Colors.primary);
exports.PinterestButton = PinterestButton;
var Line1 = (0, _uiKit.styled)("span")(_templateObject18(), _styled.HeadlineStyles1);
exports.Line1 = Line1;
var Line2 = (0, _uiKit.styled)("h3")(_templateObject19(), _styled.HeadlineStyles2);
exports.Line2 = Line2;